import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import ProductInProgressModal, { IStateProps, IDispatchProps, IOwnProps } from './ProductInProgressModal'
import {
  DashboardAction,
  requestReprint,
  requestRemoveLabels,
  requestPrint,
} from '../../services/store/actions/dashboard/DashboardAction'

import  { IStoreState } from '../../services/store/IStoreState'

function mapStateToProps(): IStateProps {
  return {}
}

function mapDispatchToProps(dispatch: Dispatch<DashboardAction>): IDispatchProps {
  return {
    requestPrint: (product) => dispatch(requestPrint({product})),
    requestReprint: (product) => dispatch(requestReprint({product})),
    requestRemoveLabels:(products) => dispatch(requestRemoveLabels({products})),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(ProductInProgressModal)
